/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HubDto } from './hubDto';
import { ShopClosingDateDto } from './shopClosingDateDto';
import { ShopServiceDto } from './shopServiceDto';
import { BusinessModelTypes } from './businessModelTypes';


export interface CustomerShopsDto { 
    shopId?: number;
    name?: string | null;
    description?: string | null;
    imageUrl?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressZipCode?: string | null;
    addressCity?: string | null;
    enShortName?: string | null;
    trayLimit?: number;
    orderPlacementRange?: number;
    hideIncompleteArticles?: boolean;
    articleRatingFilterType?: number;
    businessType?: BusinessModelTypes;
    deliveryLocationEnabled?: boolean;
    mealAtPlaceEnabled?: boolean;
    mealAtPlaceDeliveryFromTime?: string | null;
    mealAtPlaceDeliveryToTime?: string | null;
    timeSlotDuration?: number | null;
    mealAtPlaceLocations?: string | null;
    notesEnabled?: boolean;
    canteenTimeSlotsEnabled?: boolean;
    hub?: HubDto;
    shopServices?: Array<ShopServiceDto> | null;
    shopClosingDates?: Array<ShopClosingDateDto> | null;
}
export namespace CustomerShopsDto {
}


